import { z } from 'zod'
import { OptionalTextSchema } from '../shared/text'

// Páginas do CMS (PageController da API: /pages/list, /pages/get-by-slug/{slug}, /pages/search).
// O PageDTO tem `name`, `content`, `type`, `slug` e `parentId` anuláveis; a tela depende de id, name e slug, o resto é
// tolerante. Não existe rota GET /pages/{id} na API (ver PageService.getPageByIdService).

/** Tipo da página no CMS (`TypePage`: Outros, FAQ, Institucional); aceita valor novo sem quebrar a tela. */
export const PageTypeSchema = z.string()

/** Campos comuns a página e item da lista: os que a navegação e a árvore da central de ajuda usam. */
export const PageListItemSchema = z.looseObject({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
    parentId: z
        .string()
        .nullish()
        .transform((value) => value ?? null),
    active: z.boolean(),
    typePage: PageTypeSchema.nullish(),
    content: OptionalTextSchema,
    type: OptionalTextSchema,
})

/** Página completa (GET /pages/get-by-slug/{slug}): o `content` é o HTML do CMS. */
export const PageSchema = PageListItemSchema

/** GET /pages/list: páginas ativas, sem `content`. */
export const PageListResponseSchema = z.array(PageListItemSchema)

/** Resultado de GET /pages/search: projeção com trecho sem HTML. */
export const PageSearchResultSchema = z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
    parentId: z
        .string()
        .nullish()
        .transform((value) => value ?? null),
    excerpt: OptionalTextSchema,
})

export const PageSearchResponseSchema = z.array(PageSearchResultSchema)

export type IPageListItem = z.infer<typeof PageListItemSchema>
export type IPage = z.infer<typeof PageSchema>
export type IPageSearchResult = z.infer<typeof PageSearchResultSchema>
/** Nó da árvore da central de ajuda, montada no front a partir da lista. */
export type IPageNode = IPageListItem & { children: IPageNode[] }
